import React, { memo } from "react";
import SettingsTyphographyComponent from "./SettingsTyphographyComponent";
import { Grid } from "@mui/material";
import SettingsIcon from "@mui/icons-material/Settings";
import SyncIcon from "@mui/icons-material/Sync";
import { Card, Button } from "@totalsoft/rocket-ui";
import { useTranslation } from "react-i18next";
import HeaderPortal from "components/layout/HeaderPortal";
import PropTypes from "prop-types";
import { translation } from "./constants";

const SettingsComponent = ({ appVersion, databaseVersion, onResetCache, disabled }) => {
  const { t } = useTranslation();

  return (
    <>
      <Card icon={SettingsIcon} iconColor="primary" title={t("Settings.Versions.Title")}>
        <Grid container>
          <HeaderPortal />
          <Grid item xs={12}>
            <SettingsTyphographyComponent data={appVersion} translation={translation.app} />
          </Grid>
          <Grid item xs={12}>
            <SettingsTyphographyComponent data={databaseVersion} translation={translation.databaseVersion} />
          </Grid>
        </Grid>
      </Card>
      <Card icon={SyncIcon} iconColor="primary" title={t("Settings.InvalidateCache.Title")}>
        <Button wd color="primary" onClick={onResetCache} disabled={disabled}>
          {disabled ? t("Settings.InvalidateCache.ResettingCache") : t("Settings.InvalidateCache.ResetCache")}
        </Button>
      </Card>
    </>
  );
};

SettingsComponent.propTypes = {
  appVersion: PropTypes.object.isRequired,
  databaseVersion: PropTypes.object.isRequired,
  onResetCache: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired
};

export default memo(SettingsComponent);
